import React, { useEffect, useRef, useState } from "react";

import { connect } from "react-redux";
import { cloneDeep, includes, isEmpty, map, size, capitalize } from "lodash";
import Emitter from "../../utils/Emitter";

import { getCountryList, getHSCodeList, getHScodeSuggetions, getServicesList, searchPortData } from "../../actions/defaultDataAction";
import { getBuyerSupplierList } from "../../actions/memberAction";

import { default as ReactSelect, components } from "react-select";
import { WithContext as ReactTags } from "react-tag-input";

import DropDown from "../DropDown";
import Button from "../Button";
import ButtonAdminpanel from "../ButtonAdminpanel";
import { useAuth } from "../../AuthProvider";
import { showLoading } from "../../actions/loaderAction";
import defaultValues from "../../constant/defaultValues";
import ToolipsCustom from "../ToolipsCustom";
import InputField from "../../components/InputField";

const LogisticMemberFilter = (props) => {

    const { user } = useAuth();
    const { admin } = defaultValues;

    const [countryList, setCountryList] = useState([]);
    const [selected_target_country, setSelectedTargetCountry] = useState([]);
    const [searchedTxt, setSearchedTxt] = useState(null);
    const [searchMemberId, setSearchMemberId] = useState(null);
    const [portList, setPortList] = useState([]);
    const [selected_port, setSelectedPort] = useState([]);



    const filterTypeOptions = [{
        label: 'Country',
        value: 'location'
    }, {
        label: 'Company Name',
        value: 'companyName'
    }, {
        label: 'Member ID',
        value: 'member'
    },
    {
        label: 'Port',
        value: 'port'
    },

    ];

    const CustomOption = ({ innerRef, innerProps, isSelected, label }) => (

        <div ref={innerRef} {...innerProps} style={{ display: 'flex', alignItems: 'center' }} className={isSelected ? "div-item-selected" : "div-item-unselected"} >
            {/* <input type="checkbox" checked={isSelected} readOnly /> */}
            {isSelected && <div className={` item-selected `}><label style={{ marginLeft: '8px' }}>{label}</label></div>}
            {!isSelected && <div className={` item-selected2 `}><label style={{ marginLeft: '8px' }}>{label}</label></div>}

        </div>

    );

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            '&:hover': {
            },
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: '#4c9bdb', // Background of the selected multi-value items
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: '#fff', // Color of the text inside the multi-value
            fontSize: "20px"
        }),

        multiValueRemove: (provided) => ({
            ...provided,
            color: '#df0024', // Remove button color
            ':hover': {
                backgroundColor: '#df0024', // Background color on hover for the remove button
            },
        }),
    };



    const [filterTypeOptionVal, setFilterOptionVal] = useState(filterTypeOptions[0]);

    const handleFilterTypeChange = (val) => {
        setSelectedTargetCountry([]);
        setSearchedTxt(null);
        setSearchMemberId(null);
        setSelectedPort([]);
        setFilterOptionVal(val);

    }

    const MoreSelectedBadge = ({ items }) => {
        const style = {
            marginLeft: "auto",
            background: "#d4eefa",
            borderRadius: "4px",
            fontFamily: "Open Sans",
            fontSize: "11px",
            padding: "3px",
            order: 99,
        };

        const title = items.join(", ");
        const length = items.length;
        const label = `+ ${length} item${length !== 1 ? "s" : ""} selected`;

        return (
            <div style={style} title={title}>
                {label}
            </div>
        );
    };

    const MultiValue = ({ index, getValue, ...props }) => {
        const maxToShow = 3;
        const overflow = getValue()
            .slice(maxToShow)
            .map((x) => x.label);

        return index < maxToShow ? (
            <components.MultiValue {...props} />
        ) : index === maxToShow ? (
            <MoreSelectedBadge items={overflow} />
        ) : null;
    };



    const handleTargetCountryChange = (val) => {
        setSelectedTargetCountry(val);
    }


    const handleInputChange = (e) => {
        setSearchedTxt(e.target.value);
    };

    const handleInputChangeMemberId = (e) => {
        setSearchMemberId(e.target.value);
    };

    const handlePortChange = (val) => {
        setSelectedPort(val);
    }



    const handlePortInputChange = (val, actionMeta) => {
        // console.log("handleServiceInputChange >>> ", val);
        const { prevInputValue } = actionMeta;
        if (val.length >= 3) {
            getPortInList(val);
        } else if (val.length === 0 && (prevInputValue !== val)) {
            getPortInList("");
        }
    }

    const getPortInList = async (val) => {
        // console.log("val ========= ", val);
        let data = await props.searchPortData(0, 10, val);
        const capitalizeWords = (str) =>
            str
                .split(" ")
                .map(word => capitalize(word))
                .join(" ");
        let dataList = data.map((v) => {
            return {
                label: capitalizeWords(v.name) + (v.port_code ? " (" + capitalizeWords(v.port_code) + ")" : ""),
                value: v.id
            }
        });
        setPortList(dataList);
    }



    const fetchFilterSelection = async () => {

        const result = await Promise.allSettled([
            props.getCountryList(),
            props.searchPortData(0, 10, ''),

        ]);
        const capitalizeWords = (str) =>
            str
                .split(" ")
                .map(word => capitalize(word))
                .join(" ");

        result.forEach((res, indx) => {
            let dataList = [];
            let data = [];
            if (res.status === 'fulfilled') {
                if (includes([0, 1], indx)) {
                    data = res.value;
                } else if (includes([2], indx)) {
                    data = res.value.data;
                }

                if (indx === 0) {
                    dataList = data.map((v) => {
                        return {
                            label: v.name,
                            value: v.id
                        }
                    });
                    setCountryList(dataList);
                }
                if (indx === 1) {
                    dataList = data.map((v) => {
                        return {
                            label: capitalizeWords(v.name) + (v.port_code ? " (" + capitalizeWords(v.port_code) + ")" : ""),
                            value: v.id
                        }
                    });
                    setPortList(dataList);
                }

            } else {
                console.log("Something Went Wrong while fetching index ", indx, "!! ", res.reason);
            }
        });

    }


    useEffect(() => {
        // filterMembers();
        fetchFilterSelection();

    }, []);


    const filterMembers = () => {
        let user_id = 0;
        const { admin } = defaultValues;
        if (user) {
            user_id = user.id;
        }

        const filterObj = {};
        filterObj.filterBy = filterTypeOptionVal.value;
        filterObj.filter_val = "";
        // filterObj.selected_target_country = map(selected_target_country, 'value');
        let sCountry = selected_target_country ? selected_target_country.value : null;
        filterObj.selected_target_country = (sCountry > 0) ? [sCountry] : [];
        filterObj.company_name = searchedTxt;
        filterObj.memberId = searchMemberId;
        filterObj.limit = admin.LIMIT;
        filterObj.offset = admin.OFFSET;
        filterObj.selected_port = map(selected_port, 'value');
        Emitter.emit("SET_FILTER_MEMBERS", filterObj);
        setTimeout(() => {
            Emitter.emit("FILTER_MEMBERS", filterObj);
        }, 1000);

    }


    const resetFilter = () => {
        props.showLoading();
        const clearAllButton = document.getElementsByClassName("ReactTags__clearAll");
        if (clearAllButton.length > 0) {
            clearAllButton[0].click();
        } else {
            document.getElementsByClassName("search_input")[0].value = "";
        }


        const filterObj = {};
        filterObj.filterBy = filterTypeOptions[0].value;
        setFilterOptionVal(filterTypeOptions[0]);
        setSelectedTargetCountry([]);
        setSearchedTxt(null);
        setSearchMemberId(null);
        setSelectedPort([]);

        filterObj.filter_val = "";
        filterObj.selected_target_country = [];
        filterObj.selected_port = [];
        filterObj.company_name = null;
        filterObj.memberId = null;
        filterObj.table_search = "";
        filterObj.sortDirection = "DESC";
        filterObj.columnName = "id";
        filterObj.limit = admin.LIMIT;
        filterObj.offset = admin.OFFSET;

        Emitter.emit("SET_FILTER_MEMBERS", filterObj);
        setTimeout(() => {
            Emitter.emit("FILTER_MEMBERS", filterObj);
        }, 1000);

    }





    return (

        <div className="bg-white shadow rounded p-4 mb-4">

            <div className="row">

                <div className="col-xl-2 col-md-6 mt-2" >
                    <DropDown placeholder="Select.." options={filterTypeOptions} value={filterTypeOptionVal} onChange={handleFilterTypeChange} />
                </div>

                {filterTypeOptionVal && filterTypeOptionVal.value === "location" &&
                    <div className="col-xl-7 col-lg-6 col-md-6 mt-2 ">
                        <ReactSelect
                            options={countryList}
                            //isMulti
                            closeMenuOnSelect={true}
                            hideSelectedOptions={false}
                            //components={{ Option: CustomOption, IndicatorSeparator: () => null, MultiValue }}
                            onChange={handleTargetCountryChange}
                            value={selected_target_country}
                            removeSelected={false}
                            styles={customStyles}
                            placeholder="Select Country"
                            className="member-filter-container search_input"
                            classNamePrefix="member-filter-select"
                            noOptionsMessage={() => "No Country Found"}

                        />
                    </div>
                }

                {filterTypeOptionVal && filterTypeOptionVal.value === "companyName" &&
                    <div className="col-xl-7 col-lg-6 col-md-6 mt-2">
                        <InputField
                            type="text"
                            id="filter-text-box"
                            placeholder="Search Company Name"
                            className="w-25 search_input"
                            onChange={handleInputChange}
                            value={searchedTxt}
                            autoComplete="off"
                        ></InputField>
                    </div>
                }

                {filterTypeOptionVal && filterTypeOptionVal.value === "member" &&
                    <div className="col-xl-7 col-lg-6 col-md-6 mt-2">
                        <InputField
                            type="text"
                            id="filter-text-box"
                            placeholder="Search Member ID"
                            className="w-25 search_input"
                            onChange={handleInputChangeMemberId}
                            value={searchMemberId}
                            autoComplete="off"
                        ></InputField>
                    </div>
                }

                {filterTypeOptionVal && filterTypeOptionVal.value === "port" && <div className="col-md-6 col-lg-7 mt-2 ">
                    <ReactSelect
                        options={portList}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        components={{ Option: CustomOption, IndicatorSeparator: () => null, MultiValue }}
                        onChange={handlePortChange}
                        value={selected_port}
                        onInputChange={handlePortInputChange}
                        removeSelected={false}
                        // isDisabled={isSuperAdmin ? false : (props.isDisable || props.disableProfile)}
                        styles={customStyles}
                        placeholder="Select Port"
                        className="member-filter-container w-100 search_input"
                        classNamePrefix="member-filter-select"
                        noOptionsMessage={() => "No Port Found"}
                    // filterOption={customFilter}
                    // isOptionDisabled={() => hs_code.length >= 3}
                    />


                </div>}

                <div className="filter-search-btn col-xl-3 col-lg-12 d-flex align-items-center mt-2 search">
                    <ButtonAdminpanel type="button" onClick={filterMembers} className="btn-regi">  <i className="fa-solid fa-magnifying-glass text-white"></i> Search </ButtonAdminpanel>

                    <button type="button" className=" btn filter-reset-btn mx-2" onClick={resetFilter}>
                        <svg viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g fill="none" fillRule="evenodd" stroke="#000000" strokeLinecap="round" strokeLinejoin="round" transform="matrix(0 1 1 0 2.5 2.5)"> <path d="m3.98652376 1.07807068c-2.38377179 1.38514556-3.98652376 3.96636605-3.98652376 6.92192932 0 4.418278 3.581722 8 8 8s8-3.581722 8-8-3.581722-8-8-8"></path> <path d="m4 1v4h-4" transform="matrix(1 0 0 -1 0 6)"></path> </g> </g></svg>
                        Reset</button>

                </div>

            </div>





            {/* <div className="row pt-3">

                 <div className="filter-search-btn col-xl-4 col-md-6 d-flex align-items-center mt-2">
                    <ButtonAdminpanel type="button" onClick={filterMembers} className="btn-regi">  <i className="fa-solid fa-magnifying-glass text-white"></i> Search </ButtonAdminpanel>

                    <button type="button" className=" btn filter-reset-btn mx-2" onClick={resetFilter}>
                        <svg viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g fill="none" fillRule="evenodd" stroke="#000000" strokeLinecap="round" strokeLinejoin="round" transform="matrix(0 1 1 0 2.5 2.5)"> <path d="m3.98652376 1.07807068c-2.38377179 1.38514556-3.98652376 3.96636605-3.98652376 6.92192932 0 4.418278 3.581722 8 8 8s8-3.581722 8-8-3.581722-8-8-8"></path> <path d="m4 1v4h-4" transform="matrix(1 0 0 -1 0 6)"></path> </g> </g></svg>
                        Reset</button>
                   
                </div>

            </div> */}


        </div>


    )
}

const mapStateToProps = (state) => {
    return {}
}

const mapDispatchToProps = (dispatch) => {
    return {
        getCountryList: () => dispatch(getCountryList()),
        getServicesList: (offset, limit, searchTxt) => dispatch(getServicesList(offset, limit, searchTxt)),
        searchPortData: (offset, limit, searchTxt) => dispatch(searchPortData(offset, limit, searchTxt)),
        getBuyerSupplierList: (offset, limit, searchtxt) => dispatch(getBuyerSupplierList(offset, limit, searchtxt)),
        getHSCodeList: () => dispatch(getHSCodeList()),
        getHScodeSuggetions: (offset, limit, searchTxt) => dispatch(getHScodeSuggetions(offset, limit, searchTxt)),
        showLoading: () => dispatch(showLoading())
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(React.memo(LogisticMemberFilter));

